import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { formatCount } from "../Home/useAnimatedCount";

const SubscriptionOrderDetails = ({
  unitOfMeasure,
  productPrice,
  includedTokens,
  productTax,
  totalAmountWithoutTax,
  total
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">{t("Order Details")}</div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label">{t("Unit of Measure")}</label>
          <input type="text" className="form-control" value={unitOfMeasure || "-"} readOnly />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="subscriptionPrice">
            {t("Product Price ($)")}
          </label>
          <input
            type="text"
            className="form-control"
            id="subscriptionPrice"
            value={productPrice}
            readOnly
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label">{t("Included tokens")}</label>
          <input
            type="text"
            className="form-control"
            value={formatCount(includedTokens)}
            readOnly
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="subscriptionSubtotal">
            {t("Sub Total ($)")}
          </label>
          <input
            type="text"
            className="form-control"
            id="subscriptionSubtotal"
            value={totalAmountWithoutTax}
            readOnly
          />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label" htmlFor="subscriptionTax">
          {t("Tax Amount ($)")}
        </label>
        <input
          type="text"
          className="form-control"
          id="subscriptionTax"
          value={productTax}
          readOnly
        />
      </div>
      <div className="token-total-box">
        <div className="token-total-box-header">
          <span className="token-total-box-label">{t("Total Amount ($)")}</span>
          <span className="token-total-box-incl">{t("Including all taxes")}</span>
        </div>
        <div className="token-total-box-value">${total}</div>
      </div>
    </div>
  );
};

SubscriptionOrderDetails.propTypes = {
  unitOfMeasure: PropTypes.string,
  productPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  includedTokens: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  productTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  totalAmountWithoutTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

SubscriptionOrderDetails.defaultProps = {
  unitOfMeasure: ""
};

export default SubscriptionOrderDetails;
